import { valibotResolver } from '@hookform/resolvers/valibot';
import { intersect } from 'valibot';

import StepBasicInfo from '../components/BasicInfo';
import StepMaintenanceDetails from '../components/MaintenanceDetails';
import StepMetricsInfo from '../components/MetricsInfo';
import StepReplacementInfo from '../components/ReplacementInfo';
import StepVerifyReport from '../components/VerifyReport';
import {
  schemaCRStepBasic,
  schemaCRStepDetails,
  schemaCRStepMetrics,
  schemaCRStepReplaceParts,
} from '../constants/schemaCompletionReport';

export const getCompletionReportSteps = (isWwAi, noActionsSwitcher, hasLphAvoided) => {
  let steps = [];
  if (isWwAi || (!isWwAi && noActionsSwitcher === 1)) {
    steps = [
      {
        step: 1,
        stepName: 'Enter Basic Information',
        stepComponent: StepBasicInfo,
        previousStepIndex: 'close',
        nextStepIndex: 1,
        schema: valibotResolver(schemaCRStepBasic),
      },
      {
        step: 2,
        stepName: 'Verify your report',
        stepComponent: StepVerifyReport,
        previousStepIndex: 0,
        nextStepIndex: 'end',
        schema: valibotResolver(schemaCRStepBasic),
      },
    ];
  } else {
    steps = [
      {
        step: 1,
        stepName: 'Enter Basic Information',
        stepComponent: StepBasicInfo,
        previousStepIndex: 'close',
        nextStepIndex: 1,
        schema: valibotResolver(schemaCRStepBasic),
      },
      {
        step: 2,
        stepName: 'Enter Maintenance Details',
        stepComponent: StepMaintenanceDetails,
        previousStepIndex: 0,
        nextStepIndex: 2,
        schema: valibotResolver(schemaCRStepDetails),
      },
      {
        step: 3,
        stepName: 'Enter Metrics Information',
        stepComponent: StepMetricsInfo,
        previousStepIndex: 1,
        nextStepIndex: 3,
        schema: valibotResolver(schemaCRStepMetrics(hasLphAvoided)),
      },
      {
        step: 4,
        stepName: 'ENTER REPLACEMENT INFORMATION (OPTIONAL)',
        stepComponent: StepReplacementInfo,
        previousStepIndex: 2,
        nextStepIndex: 4,
        schema: valibotResolver(schemaCRStepReplaceParts),
      },
      {
        step: 5,
        stepName: 'VERIFY YOUR REPORT',
        stepComponent: StepVerifyReport,
        previousStepIndex: 3,
        nextStepIndex: 'end',
        schema: valibotResolver(
          intersect([
            schemaCRStepBasic,
            schemaCRStepDetails,
            schemaCRStepMetrics(hasLphAvoided),
            schemaCRStepReplaceParts,
          ]),
        ),
      },
    ];
  }

  return steps;
};
